export default {
  "de-DE": {
    "text001": "Der \"Wähle deine Legenden\"-Event ist zurück!",
    "text002": "Du entscheidest mit über die beiden bestplatzierten<br>männlichen und weiblichen Helden. Diese erscheinen mit besonderen<br>\"Wähle deine Legenden\"-Outfits in Fire Emblem Heroes.",
    "text003": "Alle, die an \"Wähle deine Legenden\" teilnehmen, während sie<br>bei ihrem Nintendo-Account angemeldet sind, können je nach der Anzahl<br>ihrer Abstimmungen besondere Hintergrundbilder erhalten.",
    "text004": "Außerdem erhalten sie 100<br>Platinpunkte für My Nintendo.",
    "text005": "● Die Punkte werden nach der Aktion gutgeschrieben.",
    "text006": "● Auf der Seite \"Informationen zum Event\" findest du weitere Informationen.",
    "text007": "Platinpunkte",
    "text008": "+100",
    "text009": "Ergebnisse aus Runde 1",
    "text010": "Ergebnisse aus Runde 2",
    "text011": "Ergebnisse aus Runde 3",
    "btn001": "Ergebnisse ansehen"
  },
  "en-GB": {
    "text001": "The Choose Your Legends event is back!",
    "text002": "Your choices will help determine the top two male and<br>top two female Heroes. They'll appear in the Fire Emblem<br>Heroes game in special Choose Your Legends outfits.",
    "text003": "Anyone who participates in Choose Your Legends while signed in to their Nintendo Account can receive special wallpapers based on how many times they voted.",
    "text004": "They'll also receive 100<br>Platinum Points for My Nintendo.",
    "text005": "● Points will be applied after the promotion ends.",
    "text006": "● Please check the About Choose Your Legends page for more details.",
    "text007": "Platinum Points",
    "text008": "+100",
    "text009": "Results from Round 1",
    "text010": "Results from Round 2",
    "text011": "Results from Round 3",
    "btn001": "View Results"
  },
  "es-ES": {
    "text001": "¡Vuelve el evento Elige a tus héroes!",
    "text002": "Vuestros votos decidirán quiénes son los dos héroes<br>y las dos heroínas más populares. ¡Los elegidos aparecerán en<br>Fire Emblem Heroes con atuendos especiales de Elige a tus héroes!",
    "text003": "Si participas en Elige a tus héroes<br>con una cuenta Nintendo vinculada,<br>obtendrás fondos de pantallas especiales<br>dependiendo de cuántas veces votes.",
    "text004": "También recibirás 100 puntos<br>de platino de My Nintendo.",
    "text005": "● Los puntos se sumarán una vez que finalice la promoción.",
    "text006": "● Consulta la sección \"Acerca de Elige a tus héroes\" para obtener más información.",
    "text007": "Puntos de platino",
    "text008": "+ 100",
    "text009": "Resultados de Elige a tus héroes",
    "text010": "Resultados de Elige a tus héroes (2)",
    "text011": "Resultados de Elige a tus héroes (3)",
    "btn001": "Ver resultados"
  },
  "fr-FR": {
    "text001": "« Choisissez vos héros » fait son retour !",
    "text002": "Les votes permettent de désigner les héros et les héroïnes<br>les plus populaires. Les heureux élus auront le privilège<br>de porter une tenue spéciale dans Fire Emblem Heroes.",
    "text003": "Tous les participants qui auront associé leur<br>compte Nintendo au site peuvent<br>recevoir des fonds d'écran en fonction du<br>nombre de votes effectués.",
    "text004": "Ils obtiendront également 100 points<br>platine pour My Nintendo.",
    "text005": "● Les points seront distribués une fois l'événement terminé.",
    "text006": "● Pour plus d'informations, visitez la page « À propos de l'événement ».",
    "text007": "Points platine",
    "text008": "+100",
    "text009": "Résultats de la première édition",
    "text010": "Résultats de la deuxième édition",
    "text011": "Résultats de la troisième édition",
    "btn001": "Voir les résultats"
  },
  "it-IT": {
    "text001": "L'evento Scegli le tue leggende è tornato!",
    "text002": "Puoi votare i tuoi due eroi preferiti e le tue due eroine preferite<br>per contribuire a farli apparire in Fire Emblem Heroes<br>con completi speciali Scegli le tue leggende.",
    "text003": "Coloro che accedono al proprio account Nintendo <br>e partecipano a Scegli le tue leggende <br>possono ricevere degli sfondi speciali <br>in base a quante volte hanno votato.",
    "text004": "Riceveranno inoltre 100 punti<br>di platino per My Nintendo.",
    "text005": "● I punti verranno assegnati a fine promozione.",
    "text006": "● Per maggiori informazioni, vai alla pagina Dettagli sull'evento.",
    "text007": "Punti di platino",
    "text008": "+100",
    "text009": "Risultati della prima edizione",
    "text010": "Risultati della seconda edizione",
    "text011": "Risultati della terza edizione",
    "btn001": "Vedi risultati"
  },
  "ja-JP": {
    "text001": "歴代英雄の総選挙を今年も開催！",
    "text002": "男性・女性それぞれ上位2位までが<br>特別な衣装を着た総選挙versionとして<br>ファイアーエムブレム ヒーローズに再び登場！",
    "text003": "ニンテンドーアカウントで<br>ログインして投票された方に、投票回数<br>に応じて壁紙をプレゼント！",
    "text004": "さらに、マイニンテンドーの<br>100プラチナポイントをプレゼント！",
    "text005": "※ポイントはキャンペーン終了後にプレゼントします。",
    "text006": "※詳細は「英雄総選挙の詳細」をご確認ください。",
    "text007": "プラチナポイント（共通）",
    "text008": "＋100",
    "text009": "第1回英雄総選挙の結果はこちら",
    "text010": "第2回英雄総選挙の結果はこちら",
    "text011": "第3回英雄総選挙の結果はこちら",
    "btn001": "結果を見る"
  },
  "zh-TW": {
    "text001": "今年也將舉辦歷代英雄總選舉！",
    "text002": "票選出男性角色及女性角色的前兩名<br>會穿著總選舉版本的特別服裝，<br>在Fire Emblem Heroes中再次登場！",
    "text003": "登入Nintendo Account<br>進行投票的玩家，將依照投票次數<br>獲得桌布作為禮物！",
    "text004": "此外，還能獲得My Nintendo的<br>100點白金點數！",
    "text005": "※點數將於活動結束後發放。",
    "text006": "※詳情請參閱「英雄總選舉之詳情」。",
    "text007": "白金點數（通用）",
    "text008": "＋100",
    "text009": "第1回英雄總選舉的結果",
    "text010": "第2回英雄總選舉的結果",
    "text011": "第3回英雄總選舉的結果",
    "btn001": "查看結果"
  },
  "en-US": {
    "text001": "The Choose Your Legends event is back!",
    "text002": "Your choices will help determine the top two male and<br>top two female Heroes. They'll appear in the Fire Emblem<br>Heroes game in special Choose Your Legends outfits.",
    "text003": "Anyone who participates in Choose Your Legends while signed in to their Nintendo Account can receive special wallpapers based on how many times they voted.",
    "text004": "They'll also receive 100<br>Platinum Points for My Nintendo.",
    "text005": "● Points will be applied after the promotion ends.",
    "text006": "● Please check the About Choose Your Legends page for more details.",
    "text007": "Platinum Points",
    "text008": "+100",
    "text009": "Results from Round 1",
    "text010": "Results from Round 2",
    "text011": "Results from Round 3",
    "btn001": "View Results"
  },
  "es-MX": {
    "text001": "¡Vuelve el evento Elige a tus leyendas!",
    "text002": "Sus votos decidirán quiénes son los dos héroes<br>y las dos heroínas más populares. ¡Los elegidos aparecerán en<br>Fire Emblem Heroes con atuendos especiales de Elige a tus leyendas!",
    "text003": "Si participas en Elige a tus leyendas con una cuenta Nintendo vinculada, obtendrás fondos de pantallas especiales dependiendo de cuántas veces votes.",
    "text004": "También recibirás 100 puntos<br>de platino de My Nintendo.",
    "text005": "● Los puntos se sumarán una vez que finalice la promoción.",
    "text006": "● Consulta la sección \"Acerca de Elige a tus leyendas\" para obtener más información.",
    "text007": "Puntos de platino",
    "text008": "+100",
    "text009": "Resultados de Elige a tus leyendas",
    "text010": "Resultados de Elige a tus leyendas (2)",
    "text011": "Resultados de Elige a tus leyendas (3)",
    "btn001": "Ver resultados"
  },
  "fr-CA": {
    "text001": "« Choisissez vos héros » fait son retour!",
    "text002": "Les votes permettent de désigner les héros et les héroïnes<br>les plus populaires. Les heureux élus auront le privilège<br>de porter une tenue spéciale dans Fire Emblem Heroes.",
    "text003": "Tous les participants qui auront associé leur compte Nintendo au site peuvent recevoir des fonds d'écran en fonction du nombre de votes effectués.",
    "text004": "Ils obtiendront également 100 points<br>platine pour My Nintendo.",
    "text005": "● Les points seront distribués une fois l'événement terminé.",
    "text006": "● Pour plus d'informations, visitez la page « À propos de l'événement ».",
    "text007": "Points platine",
    "text008": "+100",
    "text009": "Résultats de la première édition",
    "text010": "Résultats de la deuxième édition",
    "text011": "Résultats de la troisième édition",
    "btn001": "Voir les résultats"
  },
  "pt-BR": {
    "text001": "O evento \"Escolha suas lendas\" está de volta!",
    "text002": "Os seus votos decidirão quais são os dois heróis e duas heroínas<br>mais populares. Os escolhidos aparecerão no jogo Fire Emblem Heroes<br>com vestimentas especiais de \"Escolha suas lendas\"!",
    "text003": "Quem participar do evento Escolha suas lendas após fazer o login na sua conta Nintendo pode receber papéis de parede, dependendo do número de vezes que votou.",
    "text004": "Eles também receberão 100 pontos<br>de platina My Nintendo.",
    "text005": "● Os pontos serão recebidos após o final do evento.",
    "text006": "● Consulte a página \"Sobre Escolha suas lendas\" para mais detalhes.",
    "text007": "Pontos de platina",
    "text008": "+100",
    "text009": "Resultados da primeira edição",
    "text010": "Resultados da segunda edição",
    "text011": "Resultados da terceira edição",
    "btn001": "Ver resultados"
  }
}